import * as React from 'react';
import { NavLink } from 'react-router-dom';

const BreadCrumb = (props: any) => {
  return (
    <span>
      <NavLink {...props} >
        {props.value}
      </NavLink>
      &nbsp; > &nbsp;
    </span>
  )
}

export default BreadCrumb




// WEBPACK FOOTER //
// ./src/modules/shared/components/BreadCrumb.tsx